export { DevicesPage } from './DevicesPage'
